<template>
  <div>
    <div
      style="
        width: 100%;
        top: 0;
        z-index: 99999;
        background: #f0f1f0;
        height: 31px;
      "
    >
      <div class="container header">
        <div class="row">
          <div class="col-xs-12 col-sm-9">
            <div class="tips1">
              <img :src="require('../images/trumpet.png')" />
              <marquee
                loop="-1"
                onmouseover="this.stop()"
                onmouseleave="this.start()"
              >
                <a target="_blank" href="#/updateLog">
                  <span class="marqueeItem"
                    >[2025年12月] 更新了新一代天地图门户网站</span
                  >
                </a>
                <a target="_blank" href="#/updateLog">
                  <span class="marqueeItem"
                    >[2025年11月] 更新了审图号为“苏B(2025)026号”</span
                  >
                </a>
                <a target="_blank" href="#/updateLog">
                  <span class="marqueeItem">[2025年11月] 2025版影像上线</span>
                </a>
                <a target="_blank" href="#/updateLog">
                  <span class="marqueeItem"
                    >[2025年8月] 发布新版矢量地图注记、影像地图注记。</span
                  >
                </a>
                <a target="_blank" href="#/updateLog">
                  <span class="marqueeItem"
                    >[2025年6月] 发布了新版兴趣点（POI）数据</span
                  >
                </a>
                <a target="_blank" href="#/updateLog">
                  <span class="marqueeItem"
                    >[2024年8月] 更新江阴市2024卫星影像数据</span
                  >
                </a>
                <a target="_blank" href="#/updateLog">
                  <span class="marqueeItem"
                    >[2024年4月] 更新江阴高铁站影像和矢量地图数据</span
                  >
                </a>
              </marquee>
              <span
                class="more"
                onclick="window.open('#/updateLog')"
                style="cursor: pointer"
                >更多</span
              >
            </div>
          </div>

          <div class="col-xs-12 col-sm-3">
            <div class="user-info">
              <ul
                class="clearfix unlogin"
                id="tdt_not_login"
                style="display: none"
              >
                <li class="home">
                  <a href="http://jiangsu.tianditu.gov.cn" title="返回省级节点"
                    ><img :src="require('../images/home.png')"
                  /></a>
                </li>
                <li>
                  <a href="javascript:tologin()">统一登录</a>
                </li>
                <li>
                  <a href="https://uums.tianditu.gov.cn/register">注册</a>
                </li>
              </ul>
              <ul class="clearfix logined" id="tdt_login" style="display: none">
                <li class="home">
                  <a href="http://jiangsu.tianditu.gov.cn" title="返回省级节点"
                    ><img :src="require('../images/home.png')"
                  /></a>
                </li>
                <li class="userinfo_box">
                  <label id="loginame"></label>
                </li>
                <li>
                  <a href="./logout" class="logout">退出</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="z-index: 99999; width: 100%; background-color: #f2f2f2">
      <headV ref="headindex" />
    </div>
    <div style="width: 100%; position: absolute; background-color: #f2f2f2">
      <div class="menu_map container">
        <div class="map_box row">
          <div id="mapDiv" class="col-lg-12 col-xm-12"></div>
        </div>
      </div>
      <div class="portalMain">
        <!-- 导航栏 -->
        <div class="portalCard">
          <div class="card">
            <a
              href="./Emap/"
              target="_blank"
              rel="noreferrer"
              style="text-decoration: none"
            >
              <div>
                <img :src="require('../images/map/menu/top1.png')" alt="" />
                <p style="text-decoration: none">在线地图</p>
              </div>
            </a>
          </div>
          <div class="card">
            <a
              href="#/multiTemporal"
              target="_blank"
              rel="noreferrer"
              style="text-decoration: none"
            >
              <div>
                <img :src="require('../images/map/menu/top2.png')" alt="" />
                <p>多时相影像</p>
              </div>
            </a>
          </div>
          <div class="card">
            <a
              href="http://lbs.tianditu.gov.cn/"
              target="_blank"
              rel="noreferrer"
              style="text-decoration: none"
            >
              <div>
                <img :src="require('../images/map/menu/top3.png')" alt="" />
                <p>资源中心</p>
              </div>
            </a>
          </div>
          <div class="card">
            <a
              href="#/DownloadCentre"
              target="_blank"
              rel="noreferrer"
              style="text-decoration: none"
            >
              <div>
                <img :src="require('../images/map/menu/top5.png')" alt="" />
                <p>标准地图</p>
              </div>
            </a>
          </div>
          <div class="card">
            <a
              href="#/resource"
              target="_blank"
              rel="noreferrer"
              style="text-decoration: none"
            >
              <div>
                <img :src="require('../images/map/menu/top8.png')" alt="" />
                <p>服务列表</p>
              </div>
            </a>
          </div>
          <div class="card">
            <a
              href="#/ExamplePage"
              target="_blank"
              rel="noreferrer"
              style="text-decoration: none"
            >
              <div>
                <img :src="require('../images/map/menu/top7.png')" alt="" />
                <p>典型应用</p>
              </div>
            </a>
          </div>
        </div>
        <!-- 美好生活 -->
        <div class="portalMapServices">
          <div class="centent" style="width: 86%">
            <div class="title">
              <div class="s-leftRight"></div>
              <div class="s-text">美好生活</div>
              <div class="s-leftRight"></div>
            </div>
            <mhshV />
          </div>
        </div>
        <!-- 地图服务 -->
        <div class="portalMapServices">
          <div class="centent">
            <div class="title">
              <div class="s-leftRight"></div>
              <div class="s-text">地图服务</div>
              <div class="s-leftRight"></div>
            </div>
            <div class="option">
              <button class="button_wrapper">矢量底图</button>
              <button class="button_wrapper">矢量注记</button>
              <button class="button_wrapper optionBtnHover">影像底图</button>
              <button class="button_wrapper">影像注记</button>
              <button class="button_wrapper">境界缓存</button>
            </div>
            <div class="carouselChart">
              <div class="center">
                <div class="contentStyle carouselItem0">
                  <img :src="require('../images/map/sldt.png')" />
                  <div class="mask_box"></div>
                </div>
                <div class="contentStyle carouselItem1">
                  <img :src="require('../images/map/slzj.png')" />
                  <div class="mask_box"></div>
                </div>
                <div class="contentStyle carouselItem2">
                  <img :src="require('../images/map/yxdt.png')" />
                  <div class="mask_box"></div>
                </div>
                <div class="contentStyle carouselItem3">
                  <img :src="require('../images/map/yxzj.png')" />
                  <div class="mask_box"></div>
                </div>
                <div class="contentStyle carouselItem4">
                  <img :src="require('../images/map/jj.png')" />
                  <div class="mask_box"></div>
                </div>

                <div
                  class="mask"
                  id="mask"
                  v-on:mouseenter="onMouseEnterCarouseFun()"
                  v-on:mouseleave="onMouseLeaveCarouseFun()"
                >
                  <div class="centent">
                    <p>影像底图</p>
                    <a
                      @click="linkResource(idx)"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <button
                        type="button"
                        class="ant-btn ant-btn-default experience"
                      >
                        <span>立即体验</span>
                      </button>
                    </a>
                  </div>
                </div>
                <div
                  style="
                    position: absolute;
                    right: -10.44vw;
                    bottom: -1.042vw;
                    z-index: 1111;
                    background: rgb(255, 255, 255);
                    width: 10.417vw;
                    height: 1.042vw;
                  "
                ></div>
              </div>
            </div>
            <ul class="nd_slide">
              <li value="0"></li>
              <li value="1"></li>
              <li value="2" class="optionBtnHover"></li>
              <li value="3"></li>
              <li value="4"></li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 开发资源-->
      <div class="developingResources">
        <div class="centent">
          <div class="title">
            <div class="s-leftRight"></div>
            <div class="s-text">开发资源</div>
            <div class="s-leftRight"></div>
          </div>
          <div class="resource">
            <div class="leftApi">
              <div class="active apiItemStyle">
                <p>地图API</p>
                <img :src="require('../images/api_icon0.png')" />
              </div>
              <div class="apiItemStyle">
                <p>网页API</p>
                <img :src="require('../images/api_icon1.png')" />
              </div>
              <div class="apiItemStyle">
                <p>WEB服务API</p>
                <img :src="require('../images/api_icon2.png')" />
              </div>
              <div class="apiItemStyle">
                <p>数据API</p>
                <img :src="require('../images/api_icon3.png')" />
              </div>
              <a
                href="https://oauth.tianditu.gov.cn/login"
                target="_blank"
                rel="noreferrer"
              >
                <button class="button_wrapper developThis">
                  <span>成为开发者</span>
                  <span
                    role="img"
                    aria-label="arrow-right"
                    class="anticon anticon-arrow-right"
                    ><svg
                      viewBox="64 64 896 896"
                      focusable="false"
                      data-icon="arrow-right"
                      width="1em"
                      height="1em"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z"
                      ></path>
                    </svg>
                  </span>
                </button>
              </a>
            </div>
            <div class="rightList">
              <!-- <div class="row"> -->
              <div class="list">
                <a
                  href="http://lbs.tianditu.gov.cn/server/MapService.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div>
                    <img
                      :src="
                        require('../images/developingResources/map_API/vector_base_map.png')
                      "
                    />
                  </div>
                  <p>矢量底图</p>
                </a>
              </div>
              <div class="list">
                <a
                  href="http://lbs.tianditu.gov.cn/server/MapService.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div>
                    <img
                      :src="
                        require('../images/developingResources/map_API/vector_annotation.png')
                      "
                    />
                  </div>
                  <p>矢量注记</p>
                </a>
              </div>
              <div class="list">
                <a
                  href="http://lbs.tianditu.gov.cn/server/MapService.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div>
                    <img
                      :src="
                        require('../images/developingResources/map_API/image_base_map.png')
                      "
                    />
                  </div>
                  <p>影像底图</p>
                </a>
              </div>
              <!-- </div> -->
              <!-- <div class="row" style="margin-top: 12px"> -->
              <div class="list">
                <a
                  href="http://lbs.tianditu.gov.cn/server/MapService.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div>
                    <img
                      :src="
                        require('../images/developingResources/map_API/threeD_terrain.png')
                      "
                    />
                  </div>
                  <p>三维地形</p>
                </a>
              </div>
              <div class="list">
                <a
                  href="http://lbs.tianditu.gov.cn/server/MapService.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div>
                    <img
                      :src="
                        require('../images/developingResources/map_API/global_realm.png')
                      "
                    />
                  </div>
                  <p>全球境界</p>
                </a>
              </div>
              <div class="list">
                <a
                  href="http://lbs.tianditu.gov.cn/server/MapService.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div>
                    <img
                      :src="
                        require('../images/developingResources/map_API/terrain_shading.png')
                      "
                    />
                  </div>
                  <p>地形晕渲</p>
                </a>
              </div>
              <!-- </div> -->
            </div>
          </div>
          <div class="learnMore">
            <a href="" target="_blank" rel="noreferrer">
              <button type="button" class="button_wrapper">
                <span>了解详情&nbsp;&nbsp;</span
                ><span
                  role="img"
                  aria-label="arrow-right"
                  class="anticon anticon-arrow-right"
                  ><svg
                    viewBox="64 64 896 896"
                    focusable="false"
                    data-icon="arrow-right"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z"
                    ></path>
                  </svg>
                </span>
              </button>
            </a>
          </div>
        </div>
      </div>
      <!-- 专题频道 -->
      <div class="portalMapServices">
        <div class="centent" style="width: 82%">
          <div class="title">
            <div class="s-leftRight"></div>
            <div class="s-text">专题频道</div>
            <div class="s-leftRight"></div>
          </div>
          <ztpdV />
        </div>
      </div>
      <!-- 底部版权 -->
      <div style="width: 100%; background: #fff">
        <div class="footer_bg container">
          <div class="footer">
            <foot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import headV from "./head.vue";
import foot from "./footer.vue";
import { ref, onMounted} from "vue";
import global from "../components/global.vue";
import switchLayer from "../js/map/switchLayer.js";
import source from "../components/source.js";
const headindex = ref(null);
import { useRouter } from "vue-router";
import mhshV from "./home-mhsh.vue";
import ztpdV from "./home-ztpd.vue";
const router = useRouter();
let optionBtns = null;
let centerItems = null;
let maskP = null;
let nd_slide = null;
let maskTitle = ["矢量底图", "矢量注记", "影像底图", "影像注记", "境界缓存"];
let idx = 2,
  prevBtnIdx = 2,
  lnter = null,
  isPlay = false;

let apiItemStyle = null;
let rightList = null;
let details = null;
let leftApiKey = 0;
onMounted(() => {
  initMap();
  optionBtns = document.querySelectorAll(".option button");
  centerItems = document.querySelectorAll(
    ".carouselChart .center .contentStyle"
  );
  maskP = document.querySelector(".carouselChart .center .mask p");
  nd_slide = document.querySelectorAll(".nd_slide li");
  interval();
  for (let i = 0; i < optionBtns.length; i++) {
    const element = optionBtns[i];
    element.addEventListener("click", () => optionBtnClick(i));
    centerItems[i]
      .querySelector("img")
      .addEventListener("click", () => optionBtnClick(i));
    nd_slide[i].addEventListener("click", () => optionBtnClick(i));
  }

  apiItemStyle = document.querySelectorAll(".apiItemStyle");
  rightList = document.querySelectorAll(".rightList .list");
  details = document.querySelector(".learnMore a");
  for (let i = 0; i < apiItemStyle.length; i++) {
    const element = apiItemStyle[i];
    element.addEventListener("click", () => onclickApi(i));
  }
  modifyDom();
});
function initMap() {
  var map = L.map("mapDiv", {
    center: [global.centerY, global.centerX],
    zoomControl: false, //add
    maxZoom: 19,
    zoom: 10,
    crs: L.CRS.EPSG4326,
    attributionControl: false,
  });
  switchLayer.gettk(map);
  switchLayer.switchMap(map, {
    y: -135,
  });
  headindex.value.initMenu(1);
}

// 定时器，轮播
function interval() {
  if (isPlay) {
    // 暂停就清空计时器
    lnter && clearInterval(lnter);
    lnter = null;
    return;
  }

  lnter = setInterval(() => {
    idx++;
    if (idx > 4) {
      idx = 0;
    }
    automaticSwitch();
  }, 3000);
}
// 点击切换
function optionBtnClick(index) {
  idx = index;
  automaticSwitch();
}

// 自动切换
function automaticSwitch() {
  // 取消上一次选中样式
  optionBtns[prevBtnIdx].className = "button_wrapper";
  // 添加选中按钮样式
  optionBtns[idx].className = "button_wrapper optionBtnHover";
  // 删除选中样式
  nd_slide[prevBtnIdx].className = "";
  // 添加选中样式
  nd_slide[idx].className = "optionBtnHover";
  // 暂存下标
  prevBtnIdx = idx;
  // 修改提示文本
  maskP.innerHTML = maskTitle[idx];

  for (let i = 0; i < centerItems.length; i++) {
    const element = centerItems[i];

    // 计算每个图片需要绑定的class
    switch (idx - i) {
      case 4:
        element.className = "contentStyle carouselItem3";
        break;
      case 3:
        element.className = "contentStyle carouselItem4";
        break;
      case 2:
        element.className = "contentStyle carouselItem0";
        break;
      case 1:
        element.className = "contentStyle carouselItem1";
        break;
      case 0:
        element.className = "contentStyle carouselItem2";
        break;
      case -1:
        element.className = "contentStyle carouselItem3";
        break;
      case -2:
        element.className = "contentStyle carouselItem4";
        break;
      case -3:
        element.className = "contentStyle carouselItem0";
        break;
      case -4:
        element.className = "contentStyle carouselItem1";
        break;
    }
  }
}

//打开服务列表页面
const linkResource = (idx) => {
  const newpage = router.resolve({
    path: "/resource",
    query: { id: idx },
  });
  window, open(newpage.href, "_blank");
};
// 鼠标滑入暂停
const onMouseEnterCarouseFun = () => {
  isPlay = true;
  interval();
};
// 鼠标划出
const onMouseLeaveCarouseFun = () => {
  isPlay = false;
  interval();
};
// 点击左侧api切换
function onclickApi(index) {
  // 清空上一次的样式
  apiItemStyle[leftApiKey].className = "apiItemStyle";
  apiItemStyle[leftApiKey].querySelector(
    "img"
  ).src = require(`../images/api_icon${leftApiKey}.png`);
  // 添加选中样式
  apiItemStyle[index].className = "active apiItemStyle";
  apiItemStyle[index].querySelector(
    "img"
  ).src = require(`../images/api_icon${index}_hover.png`);
  // 保存本次点击的下标
  leftApiKey = index;
  // 点击切换
  modifyDom();
}

// 修改右侧展示内容
function modifyDom() {
  const itemApi = source.naturalResources[leftApiKey];

  for (let i = 0; i < itemApi.children.length; i++) {
    const element = rightList[i];
    const { icon, name, href } = itemApi.children[i];
    element.querySelector("img").src = icon;
    element.querySelector("p").innerHTML = name;
    element.querySelector("a").href = href;
  }
  details.href = itemApi.href;
}
</script>
<style scoped>
@import url("../css/nav.css");
@import url("../css/index.css");
@import url("../css/map.css");
@import url("../css/indexresource.css");
@import url("../css/special.css");
@import url("../css/switchLayer.css");
@import url("../css/newIndex.css");
@import url("../css/big.css");
</style>
